import CUIContainer from 'connect-dot-com-ui-components/Components/CUIContainer/CUIContainer';
import { CUIFlex } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';
import HomepageHeaderContent from '../../HomepageHeaderContent';
import SiteFooter from '../SiteFooter';
import SiteHeader from '../SiteHeader';
import { backgroundLinearGradientImageProps, baseLayoutContainerProps } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HomepageLayout = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(CUIFlex, Object.assign({
    direction: "column",
    flex: "1",
    minHeight: "100%"
  }, backgroundLinearGradientImageProps, {
    children: [/*#__PURE__*/_jsx(SiteHeader, {
      children: /*#__PURE__*/_jsx(HomepageHeaderContent, {})
    }), /*#__PURE__*/_jsx(CUIContainer, Object.assign({}, baseLayoutContainerProps, {
      bgColor: "white",
      children: children
    })), /*#__PURE__*/_jsx(SiteFooter, {})]
  }));
};
export default HomepageLayout;